export default __webpack_public_path__ + "static/media/pin-098CB3.0d8f8260.png";